import { ExternalLink } from "lucide-react";
import Reveal from "@/components/escape21/Reveal";
import CountUp from "@/components/escape21/CountUp";

const TikTok = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto grid max-w-5xl grid-cols-1 items-center gap-10 sm:grid-cols-2 sm:gap-12">
      <Reveal className="order-2 sm:order-1">
        <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/35">
          tiktok
        </span>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          conta nova, crescimento <span className="e21-serif text-green-400">absurdo</span>.
        </h2>
        <p className="mt-5 text-base text-white/55 sm:text-lg">
          abri o tiktok há 3 semanas. já são 15 mil seguidores e milhões de views
          acumulados. quem chega agora entra junto do início.
        </p>

        <div className="mt-8 grid grid-cols-2 gap-4">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
            <div className="text-3xl font-extrabold tracking-[-0.03em] text-green-400 sm:text-4xl">
              <CountUp end={15} className="tabular-nums" />
              <span className="text-xl"> mil</span>
            </div>
            <p className="mt-1 text-sm text-white/60">seguidores em 3 semanas</p>
          </div>
          <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
            <div className="text-3xl font-extrabold tracking-[-0.03em] text-green-400 sm:text-4xl">
              milhões
            </div>
            <p className="mt-1 text-sm text-white/60">de views acumulados</p>
          </div>
        </div>

        <a
          href="https://www.tiktok.com/@duducrespo__"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-bold tracking-[-0.02em] text-white transition-colors hover:bg-white/10"
        >
          @duducrespo__ <ExternalLink size={16} />
        </a>
      </Reveal>

      <Reveal delay={120} className="order-1 sm:order-2">
        <img
          src="/portfolio/feed-tiktok.jpg"
          alt="feed do tiktok"
          loading="lazy"
          className="mx-auto w-full max-w-sm rounded-2xl border border-white/10 bg-white/5"
        />
      </Reveal>
    </div>
  </section>
);

export default TikTok;
